import styled, { css } from 'styled-components';
import { getMargins, SEM_TYPOGRAPHY_ACTION_SM_LABEL, SYS_SPACE_FIXED_100, getTypographyStyles, SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_1400, SYS_BORDER_RADIUS_MAX, SEM_TYPOGRAPHY_ACTION_XS_LABEL, SEM_TYPOGRAPHY_ACTION_MD_LABEL, SYS_SIZE_FIXED_900 } from '@oneaudi/unified-web-alpha-common';
export const StyledIconButtonLabel = styled.span `
  ${(props) => getTypographyStyles(props.size === 'xs'
    ? SEM_TYPOGRAPHY_ACTION_XS_LABEL
    : props.size === 'sm'
        ? SEM_TYPOGRAPHY_ACTION_SM_LABEL
        : SEM_TYPOGRAPHY_ACTION_MD_LABEL)};
  text-align: center;
  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color;
`;
export const StyledIconButton = styled.button `
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  border-radius: ${SYS_BORDER_RADIUS_MAX};
  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, box-shadow, border-color, background;

  svg {
    flex-shrink: 0;
  }

  ${(props) => {
    if (props.disabled && !props.isLoading) {
        return css `
        cursor: not-allowed;
      `;
    }
    if (props.isLoading) {
        return css `
        cursor: progress;
      `;
    }
    return css `
      cursor: pointer;
    `;
}}

  ${(props) => props.as === 'a' &&
    css `
      box-sizing: border-box;
    `}

  ${(props) => props.size === 'md'
    ? css `
          width: ${SYS_SIZE_FIXED_1400};
          height: ${SYS_SIZE_FIXED_1400};
        `
    : props.size === 'sm'
        ? css `
            width: ${SYS_SIZE_FIXED_1200};
            height: ${SYS_SIZE_FIXED_1200};
          `
        : css `
            width: ${SYS_SIZE_FIXED_900};
            height: ${SYS_SIZE_FIXED_900};
          `}

    ${({ $selected, theme, isLoading, as }) => css `
    & + ${StyledIconButtonLabel} {
      color: ${theme.cmp.color.action.iconButton.foreground.text[$selected ? 'selected' : 'default']};
    }

    ${!isLoading &&
    as === 'button' &&
    css `
      &:disabled {
        & + ${StyledIconButtonLabel} {
          color: ${theme.cmp.color.action.iconButton.foreground.text.disabled};
        }
      }
    `}
  `}

    ${({ $selected, theme, variant, isLoading, as }) => {
    const state = $selected ? 'selected' : 'default';
    if (variant === 'primary') {
        const primary = theme.sem.color.action.primary;
        return css `
        background: ${primary.surface.fill[state]};
        color: ${primary.foreground.icon[state]};
        border: 1px solid ${primary.surface.stroke[state]};

        ${!isLoading &&
            as === 'button' &&
            css `
          &:disabled {
            background: ${primary.surface.fill.disabled};
            color: ${primary.foreground.icon.disabled};
            border: 1px solid ${primary.surface.stroke.disabled};
          }
        `}
      `;
    }
    if (variant === 'secondary') {
        const secondary = theme.sem.color.action.secondary;
        return css `
        background: ${secondary.surface.fill[state]};
        color: ${secondary.foreground.icon[state]};
        border: 1px solid
          ${isLoading ? 'transparent' : secondary.surface.stroke[state]};

        ${!isLoading &&
            as === 'button' &&
            css `
          &:disabled {
            background: ${secondary.surface.fill.disabled};
            color: ${secondary.foreground.icon.disabled};
            border-color: ${secondary.surface.stroke.disabled};
          }
        `}
      `;
    }
    const tertiary = theme.sem.color.action.tertiary;
    return css `
      background: ${tertiary.surface.fill[state]};
      color: ${tertiary.foreground.icon[state]};
      border: 1px solid ${tertiary.surface.stroke[state]};

      ${!isLoading &&
        as === 'button' &&
        css `
        &:disabled {
          background: ${tertiary.surface.fill.disabled};
          color: ${tertiary.foreground.icon.disabled};
          border: 1px solid ${tertiary.surface.stroke.disabled};
        }
      `}
    `;
}}
`;
export const StyledIconButtonContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min-content;
  gap: ${SYS_SPACE_FIXED_100};

  ${({ variant, isLoading, theme }) => {
    if (isLoading) {
        return;
    }
    if (variant === 'primary') {
        const primary = theme.sem.color.action.primary;
        return css `
        &:hover {
          & ${StyledIconButton}:not(:disabled) {
            color: ${primary.foreground.icon.hover};
            border-color: ${primary.surface.stroke.hover};
            background: ${primary.surface.fill.hover};

            + ${StyledIconButtonLabel} {
              color: ${theme.cmp.color.action.iconButton.foreground.text.hover};
            }
          }
        }

        &:active {
          & ${StyledIconButton}:not(:disabled) {
            color: ${primary.foreground.icon.pressed};
            border-color: ${primary.surface.stroke.pressed};
            background: ${primary.surface.fill.pressed};

            + ${StyledIconButtonLabel} {
              color: ${(props) => props.theme.cmp.color.action.iconButton.foreground.text
            .pressed};
            }
          }
        }
      `;
    }
    if (variant === 'secondary') {
        const secondary = theme.sem.color.action.secondary;
        return css `
        &:hover {
          & ${StyledIconButton}:not(:disabled) {
            color: ${secondary.foreground.icon.hover};
            border-color: ${secondary.surface.stroke.hover};
            background: ${secondary.surface.fill.hover};

            + ${StyledIconButtonLabel} {
              color: ${(props) => props.theme.cmp.color.action.iconButton.foreground.text.hover};
            }
          }
        }

        &:active {
          & ${StyledIconButton}:not(:disabled) {
            color: ${secondary.foreground.icon.pressed};
            border-color: ${secondary.surface.stroke.pressed};
            background: ${secondary.surface.fill.pressed};

            + ${StyledIconButtonLabel} {
              color: ${(props) => props.theme.cmp.color.action.iconButton.foreground.text
            .pressed};
            }
          }
        }
      `;
    }
    const tertiary = theme.sem.color.action.tertiary;
    return css `
      &:hover {
        & ${StyledIconButton}:not(:disabled) {
          color: ${tertiary.foreground.icon.hover};
          background: ${tertiary.surface.fill.hover};
          border-color: ${tertiary.surface.stroke.hover};

          + ${StyledIconButtonLabel} {
            color: ${theme.cmp.color.action.iconButton.foreground.text.hover};
          }
        }
      }

      &:active {
        & ${StyledIconButton}:not(:disabled) {
          color: ${tertiary.foreground.icon.pressed};
          background: ${tertiary.surface.fill.pressed};
          border-color: ${tertiary.surface.stroke.pressed};
        }

        + ${StyledIconButtonLabel} {
          color: ${theme.cmp.color.action.iconButton.foreground.text.pressed};
        }
      }
    `;
}}
`;
//# sourceMappingURL=index.styles.js.map